<template>

<div style="background-color: #495057; height:100vh;" class="flex-container">

  <div id="loginDiv">
    <  
    <h3 id="welcomeTitle"> Log in to linkdeat</h3>
        
    <div class="flex-container-first">
    
        <form @submit.prevent="login">
            <div class="form-group">
                <label for="username">Username</label>
                <input type="text" v-model="username" name="username" class="form-control" style="margin-left: 10px;" />
            </div>
            <div class="form-group">
                <label htmlFor="password">Password</label>
                <input type="password" v-model="password" name="password" class="form-control" style="margin-left: 10px;" />
            </div>
            <div class="form-group">
                <button class="btn btn-primary" >Login</button>
            </div>
        </form>
    </div>
    
    <div style="text-align:center; color: white;">
      New to linkdeat <router-link to="/signup">Sign up now »</router-link>
    </div>
  </div>
</div>


</template>

<script>
import axios from 'axios';

export default {
  name: 'Login',
  data() {
    return {
      username:'',
      password: '',
      email: '',
      error: '',
    }
  },
  created() {
    //user is not authorized
    //if (localStorage.getItem('token') === null) {
    //  this.$router.push('/login');
    //}
      localStorage.setItem('login_res', '');
  },
  methods: {
    login() {
      /*
      let user = {
        username: this.username,
        password: this.password,
        //email: this.email,
      }
      */
      let user = 'username='+this.username+'&password='+this.password
      axios.post('https://linkdeat.ddns.net/django_api/login/', user)
        .then(res => {
          //if successfull
          if (res.status === 200) {
            console.log(res)
            localStorage.setItem('login_res', res.data);

            this.$router.push('/home');
          }
        }, err => {
          this.error = err.response.data.error
        })
    }
  }
}
</script>

